// extracted by mini-css-extract-plugin
export default {"background":"home_screen_side_bar_background__YLKNu","container":"home_screen_side_bar_container__jEnq-","container_inactive":"home_screen_side_bar_container_inactive__58Bz8"};